import { Html, useProgress } from '@react-three/drei'
import React from 'react'

function Loding() {


    const { progress } = useProgress()
    console.log(progress);

    return (
        <Html>
            {/* <div className='progress'> */}
            <p className='progress'>{progress}</p>
            {/* </div> */}
        </Html>
    )
}

export default Loding